import { FunctionComponent } from "react";
import { Price, SkeletonLoader } from "@kanda-libs/ks-design-library";
import { getColor } from "components/payment/PaymentInfoBanner/PaymentPrice/helpers";
import { useSelector } from "react-redux";
import paymentSelectors from "store/selectors/payments";
import { selectors } from "store";

export interface PaymentPriceProps {}

const PaymentPrice: FunctionComponent<PaymentPriceProps> = function () {
  const isLoading = useSelector(selectors.getIsLoading);
  const payment = useSelector(paymentSelectors.getFormattedPayment);

  return (
    <SkeletonLoader
      width={60}
      height={20}
      isLoading={isLoading}
      wrapperClassName="mr-6"
      afterLoading={
        <Price
          amount={payment?.total}
          color={getColor(payment?.status)}
          wrapperClassName="my-auto"
          poundsClassName="text-14-22-em"
          centsClassName="text-14-22-em"
        />
      }
    />
  );
};

export default PaymentPrice;
